<form #form="ngForm" novalidate>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ isCheckIn ? "Etat des lieux — Entrée" : "Etat des lieux — Sortie" }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
    </div>

    <div class="modal-body">

        <!-- Détails hébergement -->
        <div class="card bg-light border-0 mb-3">
            <div class="card-body py-2 px-3">
                <div class="row g-2 align-items-center">
                    <div class="col-md-3">
                        <small class="text-muted d-block">Chambre / Espace</small>
                        <strong>{{ itemToSave.chambre_libelle || itemToSave.espace_libelle || 'N/A' }}</strong>
                    </div>
                    <div class="col-md-3">
                        <small class="text-muted d-block">Client</small>
                        <strong>{{ itemToSave.client_nom }} {{ itemToSave.client_prenom }}</strong>
                        <small *ngIf="itemToSave.client_telephone" class="d-block text-muted">
                            <i class="fa fa-phone fa-xs me-1"></i>{{ itemToSave.client_telephone }}
                        </small>
                    </div>
                    <div class="col-md-3">
                        <small class="text-muted d-block">Date entrée</small>
                        <strong>{{ itemToSave.date_debut | date:'dd/MM/yyyy HH:mm' }}</strong>
                    </div>
                    <div class="col-md-3">
                        <small class="text-muted d-block">Sortie prévue</small>
                        <strong>{{ itemToSave.date_fin | date:'dd/MM/yyyy HH:mm' }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <!-- Badge mode + alerte sortie faite -->
        <div class="mb-3 d-flex align-items-center gap-2 flex-wrap">
            <span class="badge bg-success fs-6" *ngIf="isCheckIn">
                <i class="fa fa-sign-in-alt me-1"></i>Etat d'entrée
            </span>
            <span class="badge bg-warning text-dark fs-6" *ngIf="!isCheckIn">
                <i class="fa fa-sign-out-alt me-1"></i>Etat de sortie
            </span>
            <span class="badge bg-secondary fs-6" *ngIf="isSortieFaite">
                <i class="fa fa-lock me-1"></i>Sortie déjà effectuée — consultation uniquement
            </span>
        </div>

        <!-- Commentaire entrée -->
        <div class="row g-3 mb-3">
            <div class="col-md-12">
                <label class="form-label">
                    Description (entrée)
                    <span *ngIf="isCheckIn && !isSortieFaite" class="text-danger">*</span>
                    <span *ngIf="!isCheckIn" class="badge bg-secondary ms-2 fw-normal">Référence</span>
                </label>
                <textarea class="form-control"
                    [class.is-invalid]="commentaire_check_inCtrl.invalid && commentaire_check_inCtrl.touched"
                    name="commentaire_check_in" [(ngModel)]="itemEtatDesLieux.commentaire_check_in"
                    [required]="isCheckIn && !isSortieFaite" [readonly]="!isCheckIn || isSortieFaite"
                    #commentaire_check_inCtrl="ngModel" rows="2" placeholder="Commentaire d'entrée"></textarea>
                <div class="invalid-feedback">Description entrée requise</div>
            </div>
        </div>

        <!-- Tableau état de la chambre -->
        <div class="col col-md-12">
            <strong>Etat de la chambre</strong>
            <div class="body table-responsive mt-2" style="max-height: 320px; overflow: auto;">
                <table class="table table-striped table-bordered table-sm">
                    <thead class="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Libellé</th>
                            <th>Valeur approx.</th>
                            <th>Qté début</th>
                            <th class="text-center">Etat entrée</th>
                            <th [class.text-muted]="isCheckIn">Qté fin</th>
                            <th class="text-center" [class.text-muted]="isCheckIn">Etat sortie</th>
                            <th [class.text-muted]="isCheckIn">Qté défectueuse</th>
                            <th>Préjudice</th>
                            <th>Date vérification</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsEtatDesLieuxDetail; let indice = index">
                            <td class="text-center">{{ indice + 1 }}</td>
                            <td>{{ item.libelle || item.commodite_libelle }}</td>
                            <td>{{ item.valeur_approximative | IntegerFormatPipe }}</td>

                            <!-- Colonnes entrée -->
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                    [name]="'quantite_check_in_' + indice" [(ngModel)]="item.quantite_check_in"
                                    [readonly]="!isCheckIn || isSortieFaite">
                            </td>
                            <td class="text-center">
                                <input type="checkbox" [name]="'etat_entree_' + indice" [(ngModel)]="item.etat_entree"
                                    [disabled]="!isCheckIn || isSortieFaite">
                            </td>

                            <!-- Colonnes sortie -->
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                    [name]="'quantite_check_out_' + indice" [(ngModel)]="item.quantite_check_out"
                                    [disabled]="isCheckIn || isSortieFaite">
                            </td>
                            <td class="text-center">
                                <input type="checkbox" [name]="'etat_sortie_' + indice" [(ngModel)]="item.etat_sortie"
                                    [disabled]="isCheckIn || isSortieFaite">
                            </td>
                            <td>
                                <input type="number" class="form-control form-control-sm"
                                    [name]="'quantite_defectueux_' + indice" [(ngModel)]="item.quantite_defectueux"
                                    (ngModelChange)="calculerPrejudice(item)" [disabled]="isCheckIn || isSortieFaite"
                                    min="0">
                            </td>

                            <td class="fw-bold" [class.text-danger]="item.montant_contentieux > 0">
                                {{ item.montant_contentieux | IntegerFormatPipe }}
                            </td>
                            <td>{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" (click)="activeModal.dismiss()">
            Fermer
        </button>
        <button type="button" class="btn btn-primary" [disabled]="form.invalid || isLoading || isSortieFaite"
            (click)="confirmSaveItem(itemEtatDesLieux)">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            Sauvegarder
        </button>
    </div>
</form>